import { render, staticRenderFns } from "./questionFrom.vue?vue&type=template&id=74bde17a&scoped=true"
import script from "./questionFrom.vue?vue&type=script&lang=js"
export * from "./questionFrom.vue?vue&type=script&lang=js"
import style0 from "./questionFrom.vue?vue&type=style&index=0&id=74bde17a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bde17a",
  null
  
)

export default component.exports